/** Every programme type and the kind it belongs to. A new type is one entry here. */
export const PROGRAMME_TYPES = {
    wellbeing: { label: "Wellbeing", kind: "coaching" },
    executive: { label: "Executive", kind: "coaching" },
    conditions: { label: "Condition management", kind: "coaching" },
    glp1: { label: "GLP-1 support", kind: "coaching" },
    anticoagulation: { label: "Anticoagulation care", kind: "care_team" },
};
export const careKindOf = (type) => PROGRAMME_TYPES[type]?.kind ?? "coaching";
/** "Executive coaching" or "Anticoagulation care": a programme named the way its members hear it. */
export function programmeName(type) {
    const t = PROGRAMME_TYPES[type];
    if (!t)
        return "Coaching";
    return t.kind === "coaching" ? `${t.label} coaching` : t.label;
}
export const CARE_WORDS = {
    coaching: {
        professional: "coach",
        professionals: "coaches",
        member: "coachee",
        members: "coachees",
        session: "session",
        sessions: "sessions",
        aSession: "a session",
        yourTeam: "your coach",
        area: "Coaching",
        tomorrow: "Coaching tomorrow",
        event: "Coaching session",
        professionalReason: "You are receiving this because you coach in HealthOS.",
        threadNotice: null,
        defaultTitle: "Coach",
        caseload: "Everyone you coach",
        path: "/coaching",
    },
    care_team: {
        professional: "clinician",
        professionals: "clinicians",
        member: "patient",
        members: "patients",
        session: "appointment",
        sessions: "appointments",
        aSession: "an appointment",
        yourTeam: "your care team",
        area: "Care team",
        tomorrow: "Appointment tomorrow",
        event: "Care team appointment",
        professionalReason: "You are receiving this because you care for patients in HealthOS.",
        threadNotice: "Your care team reads messages during working hours. If you need urgent medical help, call your local emergency number.",
        defaultTitle: "Clinician",
        caseload: "Everyone in your care",
        path: "/care",
    },
};
export const careWords = (kind) => CARE_WORDS[kind];
/** "Session" from "session": for the start of a sentence or a heading. */
export const capitalised = (word) => word.charAt(0).toUpperCase() + word.slice(1);
//# sourceMappingURL=care-kind.js.map